import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Component({
  selector: 'text-filter-box',
  templateUrl: './text-filter-box.component.html'
})
export class TextFilterBoxComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filterInputBox', { static: true }) filterInputBox: ElementRef;
  @Output() onFilterTextChanged = new EventEmitter<string>();
  @Input() placeholder = 'filter';

  /**
   * Can set text to restored state a filter read back out of the URL 
   * so the box shows what is actually being applied. 
   * 
   * Read once, on init, rather than bound live.
   */
  @Input() initialText = '';

  public filterText = '';
  private lastEmittedFilterText = '';
  private filterInputSubscription: Subscription;

  constructor() { }

  ngOnInit() {
    this.filterText = this.initialText || '';
    // set inital value or emptying a restored value matches the initial lastEmittedFilterText
    // and be swallowed, leaving the results filtered by a keyword no longer in the box.
    this.lastEmittedFilterText = this.filterText;
  }

  ngAfterViewInit() {
    // wait for pause in typing in the filter box, then apply filter
    this.filterInputSubscription = fromEvent<any>(this.filterInputBox.nativeElement, 'keyup').pipe(
      map(event => event.target.value),
      debounceTime(400)
    ).subscribe((value: string) => {
      if (value === this.lastEmittedFilterText) {
        return;
      }
      this.lastEmittedFilterText = value;
      this.onFilterTextChanged.emit(value);
    });
  }

  ngOnDestroy() {
    if (this.filterInputSubscription) {
      this.filterInputSubscription.unsubscribe();
    }
  }

  public clearFilter() {
    this.filterText = '';
    this.lastEmittedFilterText = this.filterText;
    this.onFilterTextChanged.emit(this.filterText);
  }
}
